import React, { Fragment, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

/**
 * A custom useEffect hook that only triggers on updates, not on initial mount
 * @param {Function} effect
 */
function useUpdateEffect(effect, deps = []) {
  const initialMount = useRef(true);

  useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false;
    } else {
      effect();
    }
  }, deps);
}

export function useConnectivityListener() {
  const [isOnline, setOnline] = useState(
    window ? window.navigator.onLine : false,
  );
  const toastId = useRef(null);

  useEffect(() => {
    const onlineHandler = () => setOnline(true);
    const offlineHandler = () => setOnline(false);

    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  }, []);

  useUpdateEffect(() => {
    const content = (
      <>
        <strong>{isOnline ? 'Online' : 'Offline'}</strong>
        <div>
          {isOnline
            ? 'Editing is available again'
            : 'Changes you make may not be saved'}
        </div>
      </>
    );

    if (isOnline && toastId.current !== null) {
      toast.dismiss(toastId.current);
      toastId.current = null;
    } else if (!isOnline) {
      toastId.current = toast.info(content, {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      });
    }
  }, [isOnline]);
}

export function ConnectivityListener() {
  useConnectivityListener();
  return null;
}
